import React, { FC, MutableRefObject } from 'react'
import { OrgSegmentModel } from '../../../models/segments/org-segment.model'
import { SegmentModel } from '../../../models/segments/segment.model'
import { numberWithCommas } from '../../../_utils/utils'
import { Tooltip } from 'antd'
import { getUnsafeExecutionText } from '../../segment-builder/helpers'
import { InfoCircleOutlined, Loading3QuartersOutlined } from '@ant-design/icons'
import { NoneValue } from '@pushly/aqe/lib/components'
import { SegmentRemoteReachApi, useSegmentRemoteReach } from '../../../hooks/use-segment-remote-reach'

type SegmentRowReachProps = {
    level: 'org' | 'domain'
    segment: OrgSegmentModel | SegmentModel
    reloadReachRef: MutableRefObject<SegmentRemoteReachApi | null>
}

export const SegmentRowReach: FC<SegmentRowReachProps> = ({ segment, reloadReachRef }) => {
    const localReach = segment instanceof SegmentModel ? segment.getEstimatedReach() : segment.getAggregateReach()

    reloadReachRef.current = useSegmentRemoteReach(segment)
    const { loading, reach: remoteReach } = reloadReachRef.current

    const reach: number | null = remoteReach ?? localReach

    // Processing
    if (segment.getComputedStatus() !== 'READY') {
        return (
            <span className="reach-tooltip segment-procesing" aria-label="Estimated reach is being calculated">
                <span className="label">Processing</span>
                <Tooltip title={getUnsafeExecutionText()}>
                    <InfoCircleOutlined className="info-icon" />
                </Tooltip>
            </span>
        )
    }

    // Loading
    if (loading) {
        return <Loading3QuartersOutlined spin={true} aria-label="Loading estimated reach" />
    }

    // Ready
    return (
        <span aria-live="polite" aria-label={`Estimated reach for ${segment.getName()}`}>
            {reach === null ? <NoneValue /> : <>{numberWithCommas(reach)}</>}
        </span>
    )
}
